import { ConformiteAssujettiType } from '../../Conformite';

export type AvancementAssujetti = {
  idAssujetti: string;
  millesime: number;
  honorabilite: number | null;
  capaciteProfessionnelleIas: number | null;
  capaciteProfessionnelleIobsp: number | null;
  formationContinueIas: number | null;
  formationContinueIobsp: number | null;
};

export enum AvancementStatus {
  INITIE = 0,
  EDITE = 50,
  COMPLET = 100,
}

export const AVANCEMENT_FIELD_BY_AXE_OPTIONNEL: Record<
  string,
  ConformiteAssujettiType
> = {
  HONORABILITE: 'honorabilite',
  FORME_CONTINUE_IAS: 'formationContinueIas',
  FORMATION_CONTINUE_IOBSP: 'formationContinueIobsp',
  CAPACITE_PRO_IAS: 'capaciteProfessionnelleIas',
  CAPACITE_PRO_IOBSP: 'capaciteProfessionnelleIobsp',
};

export function isAxeOptionnel(
  optionalAxes: string[] | null | undefined,
  field: string,
): boolean {
  return (optionalAxes ?? []).some(
    (axe) => AVANCEMENT_FIELD_BY_AXE_OPTIONNEL[axe] === field,
  );
}
